import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function AuthImage({ id, className, testId, alt = "Consultation attachment" }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url;
    api
      .get(`/files/${id}`, { responseType: "blob" })
      .then(({ data }) => {
        url = URL.createObjectURL(data);
        setSrc(url);
      })
      .catch(() => setSrc(""));
    return () => url && URL.revokeObjectURL(url);
  }, [id]);
  if (src === null) return <div className={`${className} animate-pulse bg-[#F6F1EA]`} />;
  if (!src) return <div className={`${className} bg-[#F6F1EA]`} />;
  return <img src={src} alt={alt} className={className} data-testid={testId} />;
}
